<script>
  import { page } from '@inertiajs/svelte';
  import Lightbox from '$lib/lightbox/Index.svelte';

  export let title;
  export let image;
  export let caption;

  let lightbox = {
    type: 'image',
    scrollable: false,
    image: {
      ...image,
      title: caption,
    },
  };

  let openLightbox;
  function handleOpenClick() {
    openLightbox();
  }
</script>

<section class="image">
  {#if title}
    <p class="image__title tagline">{title}</p>
  {/if}
  <div class="image__image">
    <img
      src={image.src}
      width={image.width}
      height={image.height}
      alt={image.alt}
      loading="lazy"
      on:click={handleOpenClick}
    />
    <button
      on:click={handleOpenClick}
      class="link-secondary btn-icon btn image__zoom-btn micro"
    >
      <i class="isax isax-search-zoom-in" />
      <span>{$page.props.i18n.full_size}</span>
    </button>
  </div>

  {#if caption}
    <p class="image__caption text-small">{caption}</p>
  {/if}
</section>

<Lightbox {lightbox} bind:open={openLightbox} />

<style lang="scss">
  .image {
    margin-top: 10rem;
    padding: 8rem 0;
    border-top: 1px solid $light-border;

    &__title {
      text-align: center;
      color: var(--royal-light);
    }

    &__image {
      aspect-ratio: 1.71;
      margin-top: 4rem;
      border: 1px solid $light-border;
      border-radius: 5px;
      padding: 1rem;
      display: flex;
      flex-direction: column;

      img {
        object-fit: cover;
        height: 100%;
        width: 100%;
        cursor: pointer;
      }
    }

    &__zoom-btn {
      margin-top: 1rem;
      gap: 0.8rem;
      align-self: flex-end;
    }

    &__caption {
      margin-top: 4rem;
      color: var(--royal-light);
      text-align: center;
    }
  }
</style>
